import { render, staticRenderFns } from "./QcqQualificationPage.vue?vue&type=template&id=aab0935c&scoped=true&lang=pug&"
import script from "./QcqQualificationPage.vue?vue&type=script&lang=ts&"
export * from "./QcqQualificationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab0935c",
  null
  
)

export default component.exports